import React from "react";
import {observer} from "mobx-react-lite";
import "./input.sass";
import classNames from "classnames";
import Select from "react-select";
import {ObservableList} from "../../../stores/observables/observableList";
import {KeyValue} from "../../../stores/observables/keyValue";

export interface IDropdownInputProps {
  /**
   * The value of the input
   */
  value: ObservableList<KeyValue>;

  /**
   * The validation error to show
   */
  errorText?: string | null;

  /**
   * The placeholder text
   */
  placeholder?: string;

  /**
   * A flag indicating if the control is disabled or not
   */
  disabled?: boolean;

  /**
   * A flag indicating if the control can display a loading state
   */
  isLoading?: boolean;

  /**
   * An optional function to be called when the selected value changes.
   */
  onChange?: (value: KeyValue) => void;

  /**
   * An optional ID for the input element, where the user can type text
   */
  inputId?: string;

  /**
   * On key down handler
   */
  onKeyDown?: Function;

  /**
   * An optional function to format the label of each value in the dropdown
   */
  labelFormatter?: (item: KeyValue) => string | undefined;
}

const DropdownInput: React.FC<IDropdownInputProps> = ({
  value,
  errorText = null,
  placeholder,
  disabled,
  isLoading = false,
  onChange,
  inputId = undefined,
  onKeyDown,
  labelFormatter
}) => {
  return (
    <div
      className={classNames("input-box", {
        "is-invalid": !value.isValid
      })}
    >
      <Select
        aria-label={inputId || "select-edit"}
        value={value.selectedItem}
        options={value.items}
        onChange={(option) => {
          if (option) {
            onChange?.(option);
          }
          value.setSelectedItem(option?.value ?? null);
        }}
        className="typeahead-selection"
        classNamePrefix="select"
        placeholder={placeholder ?? "Select"}
        isLoading={isLoading ?? false}
        isDisabled={disabled || false}
        inputId={inputId}
        onKeyDown={(e) => onKeyDown?.(e)}
        formatOptionLabel={labelFormatter}
      />
      {errorText && !value.isValid && <label>{errorText}</label>}
    </div>
  );
};

export default observer(DropdownInput);
